var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAirlineTicket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9062 5.125H16.2188C16.3596 5.125 16.4948 5.06903 16.5944 4.9694C16.694 4.86977 16.75 4.73465 16.75 4.59375V3H10.375V4.59375C10.375 4.73465 10.431 4.86977 10.5306 4.9694C10.6302 5.06903 10.7654 5.125 10.9062 5.125Z",
    fill: "url(#paint0_linear_4402_12153)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3125 24.9333V10.9333C9.3125 10.1907 9.64832 9.47854 10.2461 8.95343C10.8439 8.42833 11.6546 8.13333 12.5 8.13333H23.125V4.86667C23.125 4.3716 22.9011 3.8968 22.5026 3.54673C22.1041 3.19667 21.5636 3 21 3H18.875V4.4C18.875 5.01884 18.5951 5.61233 18.097 6.04992C17.5989 6.4875 16.9232 6.73333 16.2188 6.73333H10.9062C10.2018 6.73333 9.52614 6.4875 9.028 6.04992C8.52985 5.61233 8.25 5.01884 8.25 4.4V3H6.125C5.56141 3 5.02091 3.19667 4.6224 3.54673C4.22388 3.8968 4 4.3716 4 4.86667V29.1333C4 29.6284 4.22388 30.1032 4.6224 30.4533C5.02091 30.8033 5.56141 31 6.125 31H21C21.5636 31 22.1041 30.8033 22.5026 30.4533C22.9011 30.1032 23.125 29.6284 23.125 29.1333V27.7333H12.5C11.6546 27.7333 10.8439 27.4383 10.2461 26.9132C9.64832 26.3881 9.3125 25.6759 9.3125 24.9333Z",
    fill: "url(#paint1_linear_4402_12153)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.375 10H13.5625C12.9989 10 12.4584 10.1967 12.0599 10.5467C11.6614 10.8968 11.4375 11.3716 11.4375 11.8667V24C11.4375 24.4951 11.6614 24.9699 12.0599 25.3199C12.4584 25.67 12.9989 25.8667 13.5625 25.8667H27.375C27.9386 25.8667 28.4791 25.67 28.8776 25.3199C29.2761 24.9699 29.5 24.4951 29.5 24V11.8667C29.5 11.3716 29.2761 10.8968 28.8776 10.5467C28.4791 10.1967 27.9386 10 27.375 10ZM16.5269 20.8733C16.4247 20.8865 16.3209 20.8865 16.2188 20.8733C15.9889 20.8733 15.7652 20.8078 15.5812 20.6867C15.4493 20.5997 15.3422 20.487 15.2684 20.3574C15.1947 20.2278 15.1562 20.0849 15.1562 19.94V17.8773H17.2812V18.7173L20.405 17.9333L19.3425 17C19.2857 16.946 19.2167 16.9031 19.1398 16.8742C19.0629 16.8453 18.9799 16.8309 18.8963 16.832H16.8563V14.9653H18.875C19.239 14.9641 19.5996 15.0271 19.9355 15.1505C20.2713 15.274 20.5755 15.4554 20.83 15.684L22.6681 17.2987L25.3881 16.58L26.0044 18.372L16.5269 20.8733Z",
    fill: "url(#paint2_linear_4402_12153)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4402_12153",
    x1: 13.5625,
    y1: 3,
    x2: 13.5625,
    y2: 5.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18C19F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88C5B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4402_12153",
    x1: 13.5625,
    y1: 3,
    x2: 13.5625,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18C19F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BF3AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4402_12153",
    x1: 20.4688,
    y1: 10,
    x2: 20.4687,
    y2: 25.8667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18C19F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BF3AF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirlineTicket);
export default __webpack_public_path__ + "static/media/Airline Ticket.6b79fa64b02d1d7b10e1b9ba2f3d71ed.svg";
export { ForwardRef as ReactComponent };